import { useEffect, useState } from "react";

export const useSetValue = <T>(initialValue?: T): [T | null, (value?: T) => void, (value?: T) => void] => {
  const [value, setValue] = useState<T | null>(null);

  useEffect(() => {
    initialValue && setState(initialValue);

    // eslint-disable-next-line
  }, []);

  const setState = (value?: T) => setValue(value || null);

  const removeState = (value?: T) => setValue(value || null);

  return [value, setState, removeState];
};
